import Modal from './modal';
import Deferred from './deferred';

export default class ModalWithResult extends Modal {
    constructor(...args) {
        super(...args);
        this.deferred = null;
    }

    open() {
        super.open();
        this.deferred = new Deferred();
        return this.deferred.promise.then((result) => {
            this.cleanupPromise();
            return result;
        }, (error) => {
            this.cleanupPromise();
            return Promise.reject(error);
        });
    }

    cleanupPromise() {
        this.deferred = null;
    }

    close() {
        super.close();
        if (this.deferred) {
            this.deferred.reject();
        }
    }

    resolve(result, close = true) {
        if (this.deferred) {
            this.deferred.resolve(result);
        }
        if (close) {
            this.close();
        }
    }

    reject(reason, close = true) {
        if (this.deferred) {
            this.deferred.reject(reason);
        }
        if (close) {
            this.close();
        }
    }
}
